import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Page from './Page'
import Loading from '../components/Loading'
import Experience from '../components/Experience'
import Results from '../components/Results'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import object_value from '../api/object_value'
import shortid from 'shortid'

@inject('user', 'experiences', 'userById')
@observer
class ExperiencePage extends Component {
  constructor(props) {
    super(props)

    const page_id = object_value(props, 'match.params.id')
    const experience = props.experiences.get(page_id)
    console.log('ExperiencePage.js - constructor() - experience', experience)

    this.state = {
      page_id
    }
  }

  // Update content on route change without infinite loop
  componentWillUpdate(nextProps, nextState) {
    console.log('ExperiencePage.js - componentWillUpdate()')
    let old_id = this.props.match.params.id
    let next_id = nextProps.match.params.id
    if (old_id !== next_id) {
      // Clean before next
      nextProps.experiences.clean()
      // Get next
      nextProps.experiences.get(next_id)
    }
  }

  // Clean on leave
  componentWillUnmount() {
    this.props.experiences.clean()
  }

  render () {
    let experience = this.props.experiences
    const {page_id} = this.state
    console.log('ExperiencePage.js - render() - experience', experience)

    let category_id = object_value(experience, 'data.category.id')

    if (!experience) {
      return (<Page title='Experience' />)
    }

    return (
      <Page title='Experience' key={shortid.generate()}>
        {!experience.loaded &&
        <div><Loading /></div>}

        {experience.loaded &&
        <Experience experience={experience.data} />}

        {category_id &&
        <Results type='mosaic'
                 categoryId={category_id.toString()}
                 excludeIds={[page_id.toString()]}
                 maxCategoryExperiences={4} />}
      </Page>
    )
  }
}

const numberOrString = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
])

ExperiencePage.propTypes = {
  match: PropTypes.any,
  id: numberOrString,
  user: MobxPropTypes.observableObject,
  experiences: MobxPropTypes.observableObject,
  userById: MobxPropTypes.observableObject,
  experience: PropTypes.any
}

export default ExperiencePage



// WEBPACK FOOTER //
// ./src/containers/ExperiencePage.js